import React from 'react'
import Title from '../../../components/Title/Title'
import OCTable from './components/OCTable/OCTable'
import { array2027 } from '../../../common/constants/organizingCommittee'


const OrganizingCommittee2027page = () => {
    return (
        <div>
            <Title>Organizing Committee</Title>
            <OCTable array={array2027} />
        </div>
    )
}

export default OrganizingCommittee2027page
